import { render, staticRenderFns } from "./ChildReviewsComponent.vue?vue&type=template&id=c1d50208"
import script from "./ChildReviewsComponent.vue?vue&type=script&lang=js"
export * from "./ChildReviewsComponent.vue?vue&type=script&lang=js"
import style0 from "./ChildReviewsComponent.vue?vue&type=style&index=0&id=c1d50208&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports